import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  type ApplicationConfig,
  provideAppInitializer,
  provideCheckNoChangesConfig,
} from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { authInterceptor } from "@core/auth/auth.interceptor";
import { authInitializer } from "@core/auth/auth-initializer";
import { routes } from "./routes/routes";
import { zodLocaleInitializer } from "@core/locale/zod-locale-initializer";

export const appConfig: ApplicationConfig = {
  providers: [
    /**
     * Gets the user based on cookie authentication
     * This is ran before AppComponent is loaded, navigation/routing is done and route-guards are executed.
     * This ensures that we have a loaded application user before the application is rendered.
     */
    provideAppInitializer(authInitializer),
    provideAppInitializer(zodLocaleInitializer),
    provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withComponentInputBinding()),
  ],
};
